import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "../lib/api";

const CurrencyCtx = createContext(null);

const FALLBACK = [
  { code: "USD", symbol: "$" },
  { code: "AUD", symbol: "A$" },
  { code: "GBP", symbol: "\u00a3" },
  { code: "CAD", symbol: "C$" },
  { code: "EUR", symbol: "\u20ac" },
  { code: "NGN", symbol: "\u20a6" }
];

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrencyState] = useState(localStorage.getItem("gp_currency") || "USD");
  const [currencies, setCurrencies] = useState(FALLBACK);

  useEffect(() => {
    axios.get(`${API}/payments/currencies`).then(r => setCurrencies(r.data)).catch(() => {});
  }, []);

  const setCurrency = (c) => {
    setCurrencyState(c);
    localStorage.setItem("gp_currency", c);
  };

  const current = currencies.find(c => c.code === currency) || currencies[0];
  const format = (amount) => {
    const n = currency === "NGN" ? Math.round(amount) : Math.round(amount * 100) / 100;
    const str = currency === "NGN" ? n.toLocaleString() : n.toFixed(n % 1 === 0 ? 0 : 2);
    return `${current.symbol}${str}`;
  };

  return (
    <CurrencyCtx.Provider value={{ currency, setCurrency, currencies, symbol: current.symbol, format }}>
      {children}
    </CurrencyCtx.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyCtx) || { currency: "USD", symbol: "$", format: (n) => `$${n}`, currencies: FALLBACK, setCurrency: () => {} };
